module.exports = __webpack_public_path__ + "media/components/video_discovery/assets/Search-eeed3a6d21c56bf71aaec526cc523d82.svg";